// extracted by mini-css-extract-plugin
export var button = "pricing-module--button--my9Ik";
export var blocked = "pricing-module--blocked--1e1QJ";
export var ___gatsby = "pricing-module--___gatsby--bjd-u";
export var loader = "pricing-module--loader--4uLSN";
export var container = "pricing-module--container--28tSx";
export var container__boxes = "pricing-module--container__boxes--2PkRZ";
export var container__boxes__section = "pricing-module--container__boxes__section--MTHzK";
export var container__boxes__section__box = "pricing-module--container__boxes__section__box--3rieo";